














import { Component, Vue } from 'vue-property-decorator';
import LastWave from '@/components/LastWave.vue'; // @ is an alias to /src

@Component({
  components: {
    LastWave,
  },
  data() {
    let shouldShowSnackbar = true;
    if (localStorage.getItem('hideSnackBar')) {
      shouldShowSnackbar = false;
    }
    return {
      showSnackBar: shouldShowSnackbar,
    };
  },
  methods: {
    hideSnackbar() {
      localStorage.setItem('hideSnackBar', 'true');
    },
  },
})
export default class Home extends Vue {}
